import { CaseAdmin, CaseSpecimenAdmin, SpecimenAdmin } from "pwapi";

import { CaseAdminDetail } from "shared/reducers/admin/adminCaseReducer";
import {
  formatTimestampForDateTime,
  prepareDatetimeStringForAPI,
} from "shared/utils/dates";
import { shallowLeftDiff } from "shared/utils/formUtils";

export const initialValuesForSpecimen = (
  adminCase: CaseAdminDetail,
  specimen?: SpecimenAdmin | CaseSpecimenAdmin
) => {
  return {
    ...(specimen ||
      ({ name: "", protocol_overrides: [] } as
        | SpecimenAdmin
        | CaseSpecimenAdmin)),
    collected_date:
      specimen?.collected_date &&
      formatTimestampForDateTime(
        specimen.collected_date,
        adminCase.collected_date_timezone
      ),
    received_date:
      specimen?.received_date &&
      formatTimestampForDateTime(
        specimen.received_date,
        adminCase.received_date_timezone
      ),
  };
};

export const submissionFieldsForSpecimen = (
  adminCase: CaseAdminDetail,
  specimen?: SpecimenAdmin | CaseSpecimenAdmin,
  values?: Partial<SpecimenAdmin | CaseSpecimenAdmin>
) => {
  if (!values) values = initialValuesForSpecimen(adminCase, specimen);

  return {
    clinical_history: values.clinical_history || null,
    gross_description: values.gross_description || null,
    materials_received: values.materials_received || null,
    name: values.name || null,
    protocol_overrides: values.protocol_overrides || null,

    ...(adminCase.source === CaseAdmin.source.PW
      ? {
          collected_date:
            values.collected_date &&
            prepareDatetimeStringForAPI(
              values.collected_date,
              adminCase.collected_date_timezone
            ),
          received_date:
            values.received_date &&
            prepareDatetimeStringForAPI(
              values.received_date,
              adminCase.received_date_timezone
            ),
          type: values.type || null,
          site: values.site || null,
          procedure: values.procedure || null,
          icd10code_ids: values.icd10codes
            ? (values.icd10codes.map((c) => c?.id).filter((c) => c) as number[])
            : undefined,
        }
      : {
          source: values.source || null,
        }),
  };
};

export const shallowSpecimenComparison = (
  adminCase: CaseAdminDetail,
  specimen: SpecimenAdmin | CaseSpecimenAdmin,
  values: Partial<SpecimenAdmin | CaseSpecimenAdmin>
) => {
  const oldValues = submissionFieldsForSpecimen(adminCase, specimen);
  const newValues = submissionFieldsForSpecimen(adminCase, specimen, values);

  return shallowLeftDiff<ReturnType<typeof submissionFieldsForSpecimen>>(
    oldValues,
    newValues
  );
};
